module.exports = __webpack_public_path__ + "static/media/delete.1850a958.svg";